import React from 'react';

import HomeIcon from './home-selected.svg';

import BusSelectedIcon from './bus-selected.svg';
import BusUnSelectedIcon from './bus-unselected.svg';

import SchoolSelectedIcon from './school-selected.svg';
import SchoolUnSelectedIcon from './school-unselected.svg';

import GrocerySelectedIcon from './grocery-selected.svg';
import GroceryUnSelectedIcon from './grocery-unselected.svg';

import RestaurantSelectedIcon from './restaurant-selected.svg';
import RestaurantUnSelectedIcon from './restaurant-unselected.svg';

import HospitalSelectedIcon from './hospital-selected.svg';
import HospitalUnSelectedIcon from './hospital-unselected.svg';

import ParkSelectedIcon from './park-selected.svg';
import ParkUnSelectedIcon from './park-unselected.svg';

import CompanySelectedIcon from './company-selected.svg';
import CompanyUnSelectedIcon from './company-unselected.svg';

export interface MarkProps extends React.SVGAttributes<SVGElement> {
  selected: boolean;
}

export { HomeIcon };

const MarkComponentGenerator =
  (
    selected: React.FunctionComponent<React.SVGAttributes<SVGElement>>,
    unSelected: React.FunctionComponent<React.SVGAttributes<SVGElement>>
  ): React.FC<MarkProps> =>
  ({ selected: isSelected, ...props }) => {
    return isSelected ? React.createElement(selected, props) : React.createElement(unSelected, props);
  };

export const CommunicationIcon = MarkComponentGenerator(BusSelectedIcon, BusUnSelectedIcon);

export const SchoolIcon = MarkComponentGenerator(SchoolSelectedIcon, SchoolUnSelectedIcon);

export const ShoppingDistrictIcon = MarkComponentGenerator(GrocerySelectedIcon, GroceryUnSelectedIcon);

export const RestaurantIcon = MarkComponentGenerator(RestaurantSelectedIcon, RestaurantUnSelectedIcon);

export const HospitalIcon = MarkComponentGenerator(HospitalSelectedIcon, HospitalUnSelectedIcon);

export const ParkIcon = MarkComponentGenerator(ParkSelectedIcon, ParkUnSelectedIcon);

export const OfficeIcon = MarkComponentGenerator(CompanySelectedIcon, CompanyUnSelectedIcon);
